import substrateResponseBodyToExecuteSearchResponseBody from './substrateResponseBodyToExecuteSearchResponseBody';
import SubstrateSearchRequest from '../../../data/schema/SubstrateSearchRequest';
import SubstrateSearchResponse from '../../../data/schema/SubstrateSearchResponse';
import ExecuteSearchJsonResponse from 'owa-service/lib/contract/ExecuteSearchJsonResponse';
import ExecuteSearchResponseMessage from 'owa-service/lib/contract/ExecuteSearchResponseMessage';

export default async function substrateResponseToExecuteSearchResponse(
    response: Response,
    substrateSearchResponseBody: SubstrateSearchResponse,
    substrateSearchRequest: SubstrateSearchRequest
): Promise<ExecuteSearchJsonResponse> {
    /**
     * - If there's no response, return the ExecuteSearch equivalent of a 504.
     * - If there's a non-200 response, return a response with error message.
     * - If there's a 200 response, convert 3S response to ExecuteSearch response
     *   and return.
     */
    if (response) {
        if (response.status !== 200) {
            // Return a response object with the error from the server.
            return {
                Body: {
                    MessageText: getError(response, substrateSearchResponseBody),
                },
            };
        } else {
            // Transforms 3S response to ExecuteSearch response.
            const executeSearchResponse: ExecuteSearchResponseMessage = substrateResponseBodyToExecuteSearchResponseBody(
                substrateSearchResponseBody,
                substrateSearchRequest
            );

            // Return a successful response object containing the search results.
            return {
                Body: {
                    ...executeSearchResponse,
                },
            };
        }
    }

    // If no response was received, return this message (equivalent to a 504).
    return {
        Body: {
            MessageText: 'No response received',
        },
    };
}

const getError = (
    response: Response,
    substrateSearchResponseBody: SubstrateSearchResponse
): string => {
    if (substrateSearchResponseBody && substrateSearchResponseBody.error) {
        return JSON.stringify(substrateSearchResponseBody.error);
    }

    return response.statusText;
};
